import { Dialog, DialogContent, DialogTopSection, Button } from '@blockpot-dev/block-pot-design-system'
import { ElevatedIcon } from '@blockpot-dev/block-pot-design-system'
import { XIcon } from 'lucide-react'
import useLotteryRound from '@/hooks/contracts/lottery/useLotteryRound'
import { useMissedDraw } from '@/providers/MissedDrawProvider'
import { useLotteryDraw } from '@/providers/BlockPotDrawProvider'
import { useMissedDrawDialogOpen } from '@/providers/ModalOpenStateProvider'

export type MissedDrawDialogProps = {
    roundIndex: number
}

export default function MissedDrawDialog(props: MissedDrawDialogProps) {
    const { roundIndex } = props
    const round = useLotteryRound(roundIndex)
    const { markRoundAsSeen } = useMissedDraw()
    const { replayDraw } = useLotteryDraw()
    const missedDrawDialogOpen = useMissedDrawDialogOpen()

    if (!round) return null

    const handleClose = () => {
        markRoundAsSeen(roundIndex)
        missedDrawDialogOpen.update(false)
    }

    const handleWatchDraw = () => {
        replayDraw(roundIndex)
        markRoundAsSeen(roundIndex)
        missedDrawDialogOpen.update(false)
    }

    const potNumber = round.potIndex.toString()
    const roundNumber = (round.roundIndexInPot + 1).toString()

    return (
        <Dialog open={missedDrawDialogOpen.value} onOpenChange={handleClose}>
            <DialogContent showCloseButton={false}>
                <DialogTopSection
                    icon={<ElevatedIcon src='/assets/pngs/clock-badge.png' alt='' />}
                    title='YOU MISSED THE DRAW!'
                />
                <div className='px-4 pb-4'>
                    <p className='text-base text-secondary-foreground text-center'>
                        {`The draw for `}<span className='font-bold text-foreground'>{`Pot #${potNumber} - Round ${roundNumber}`}</span>{` has already taken place. You can rewatch the draw to see if you won.`}
                    </p>
                    <div className='flex justify-center pt-6'>
                        <Button
                            onClick={handleWatchDraw}
                            className='uppercase font-bold'
                        >
                            WATCH THE DRAW
                        </Button>
                    </div>
                </div>
                <Button
                    variant='ghost'
                    size='icon'
                    className='absolute top-4 right-4 size-6 p-0'
                    onClick={handleClose}
                >
                    <XIcon className='size-6' />
                </Button>
            </DialogContent>
        </Dialog>
    )
}
